export default function ProjectsIcon({ size = 41 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 41 41"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H37C39.2091 0 41 1.79086 41 4V37C41 39.2091 39.2091 41 37 41H4C1.79086 41 0 39.2091 0 37V4Z"
        fill="#ACADFF"
      />
      <rect
        x="3.9126"
        y="3.9126"
        width="33.1748"
        height="33.1748"
        rx="4"
        fill="#ACADFF"
      />
      <path
        d="M14.3134 15.9669V12.9782C14.3134 12.428 14.775 11.9819 15.3445 11.9819H21.9583L24.0205 13.9744H29.78C30.3495 13.9744 30.8111 14.4205 30.8111 14.9707V24.9331C30.8111 25.4833 30.3495 25.9293 29.78 25.9293H26.6867V28.918C26.6867 29.4683 26.2251 29.9143 25.6556 29.9143H11.2201C10.6506 29.9143 10.189 29.4683 10.189 28.918V16.9631C10.189 16.4129 10.6506 15.9669 11.2201 15.9669H14.3134ZM14.3134 17.9594H12.2512V27.9218H24.6245V25.9293H14.3134V17.9594ZM16.3756 13.9744V23.9368H28.7489V15.9669H23.1663L21.1041 13.9744H16.3756Z"
        fill="#4448C1"
      />
    </svg>
  );
}
